

















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { User, Repository } from '@/controllers/api/types';
import { SearchMode } from '@/global';

@Component
export default class ItemTile extends Vue {
  @Prop() readonly item!: User | Repository;
  @Prop() readonly type!: SearchMode.user | SearchMode.repo;

  private readonly isRepo: boolean = this.type === SearchMode.repo;
  private readonly isUser: boolean = this.type === SearchMode.user;
}
